"use client";

import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Scale, FileText, Building2, Briefcase, Users, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegalServices() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const services = [{
    icon: Scale,
    title: "Hukum Perdata & Pertanahan",
    items: ["Konsultasi hukum preventif untuk mencegah potensi masalah hukum di masa depan\n", "Ownership Disputes", "Compensation Claims", "Land Certificates"]
  }, {
    icon: FileText,
    title: "Hukum Pidana",
    items: ["Strong defense and victim assistance with robust legal strategies", "Legal Audit\n", "Victim Assistance", "Pre-trial Proceedings"]
  }, {
    icon: Building2,
    title: "Hukum Administrasi Negara",
    items: ["Professional handling of state administrative disputes and government administration", "Administrative Disputes", "Drafting Dokumen\n", "Judicial Review"]
  }, {
    icon: Briefcase,
    title: "Hukum Bisnis & Korporasi",
    items: ["Legal consultation for business, corporate, and investment matters to support your business growth", "Business Contracts", "Licensing", "Legal Opinion\n"]
  }, {
    icon: Users,
    title: "Hukum Ketenagakerjaan",
    items: ["Resolution of labor and industrial relations matters for companies and employees", "Termination & Severance", "Employment Agreements", "Industrial Disputes"]
  }, {
    icon: Shield,
    title: "Layanan Preventif",
    items: ["Preventive legal consultation to avoid potential future legal issues", "Legal Audit", "Document Drafting", "Legal Opinion"]
  }];
  return <section id="legal-services" ref={sectionRef} className="dark bg-background text-foreground py-20 px-4">
      <div className="max-w-screen-xl mx-auto">
        <div className={`mb-16 text-center transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-5xl font-extrabold mb-4 !text-[hsl(35,88%,47%)]">Layanan Hukum Kami</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">Solusi hukum komprehensif untuk berbagai kebutuhan Anda dengan pendekatan profesional dan berintegritas</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className={`bg-secondary border border-border hover:border-primary/50 hover:bg-secondary-hover transition-all duration-300 group ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4">
                    <Icon className="w-12 h-12 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {service.items.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-muted-foreground text-base group-hover:text-foreground transition-colors duration-300">
                        <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-muted-foreground group-hover:bg-primary flex-shrink-0 transition-colors duration-300" />
                        <span>{item}</span>
                      </li>)}
                  </ul>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}